import React, { useCallback, useEffect, useState } from 'react';
import moment from 'moment';
import { useNavigate } from 'react-router-dom';
import { Button, Grid, Typography, TextField, Box, FormControl, InputLabel, Select } from "@mui/material";
import { Search as IconSearch } from "@mui/icons-material";

import * as catalogoService from "../../services/catalogoService";
import { getsUsuarioView } from "../../services/usuarioService";
import DataGridBase from "../../components/common/DataGridBase";
import { useMantenimiento } from "../../hooks/useMantenimiento";

// Mantenimiento de usuarios del sistema: codigo, persona, clave, estado y los
// roles que tiene.
const Index = () => {
    const { isReadOnly } = useMantenimiento("usuario");
    const navigate = useNavigate();

    const [filters, setFilters] = useState({ nombres: "", idEstado: 0 });
    const [listEstado, setListEstado] = useState([]);
    const [results, setResults] = useState([]);
    const [cargando, setCargando] = useState(true);

    const fetchResults = useCallback(async () => {
        setCargando(true);

        const data = await getsUsuarioView({
            nombres: filters.nombres == null ? "" : filters.nombres,
            idEstado: filters.idEstado == null ? 0 : filters.idEstado,
        }).catch((err) => { console.log("Err: ", err) });

        // El grid pide un id unico por fila: el usuario se identifica por su
        // codigo.
        setResults((data || []).map((row) => ({ ...row, id: row.codigo })));
        setCargando(false);
    }, [filters])

    const fetchListEstado = useCallback(async () => {
        const data = await catalogoService.getCatalogosByPadre(1)
            .catch((err) => { console.log("Err: ", err) });

        setListEstado(data || []);
    }, [])

    useEffect(() => {
        fetchResults();
        fetchListEstado();
    }, [])

    const columns = [
        { field: 'codigo', headerName: 'Codigo', width: 100, sortable: false, headerAlign: 'center', align: 'center'
            , renderCell: (cellValues) => (
                <Box sx={{ cursor: 'pointer', textDecoration: 'underline' }}
                    onClick={() => navigate("/security/user/edit/" + encodeURIComponent(cellValues.row.codigo))}>
                    {cellValues.row.codigo}
                </Box>
            )
        },
        { field: 'nombres', headerName: 'Nombres', width: 220, sortable: false, headerAlign: 'left' },
        { field: 'numeroDocumento', headerName: 'Documento', width: 120, sortable: false, headerAlign: 'center', align: 'center' },
        { field: 'roles', headerName: 'Roles', width: 200, sortable: false, headerAlign: 'left' },
        { field: 'fechaVencimientoClave', headerName: 'Vence Clave', width: 120, type: 'date'
            , valueFormatter: (value) => moment(value).format('D/MM/YYYY')
            , sortable: false, headerAlign: 'center', align: 'center' },
        { field: 'estado', headerName: 'Estado', width: 90, sortable: false, headerAlign: 'center', align: 'center' },
        { field: 'fechaRegistro', headerName: 'Registro', width: 110, type: 'date'
            , valueFormatter: (value) => moment(value).format('D/MM/YYYY')
            , sortable: false, headerAlign: 'center', align: 'center' },
    ];

    return (
        <div>
            <Grid container>
                <Grid item>
                    <Typography variant="h6" sx={{ fontWeight: 'bold' }}>
                        Usuarios
                    </Typography>
                </Grid>
                <Grid container spacing={1} alignItems={"center"} padding={"12px 0px 0px 0px"}>
                    <Grid item xs={8} sm={4}>
                        <TextField
                            name="nombres"
                            label="Codigo o nombres"
                            value={filters.nombres}
                            fullWidth
                            onChange={(event) => setFilters({ ...filters, nombres: event.target.value })}
                            onKeyDown={(event) => {
                                if (event.key === "Enter") {
                                    event.preventDefault();
                                    fetchResults();
                                }
                            }}
                            size="small"
                        />
                    </Grid>
                    <Grid item xs={8} sm={2}>
                        <FormControl fullWidth>
                            <InputLabel htmlFor="input-estadousuario">Estado</InputLabel>
                            <Select
                                native
                                label="Estado"
                                value={filters.idEstado}
                                onChange={(event) => setFilters({ ...filters, idEstado: parseInt(event.target.value) })}
                                inputProps={{ name: 'idEstado', id: 'input-estadousuario' }}
                                size="small"
                            >
                                <option key={0} value={0}>{"(Todos)"}</option>
                                {listEstado.map((row) => (
                                    <option key={row.id} value={row.id}>{row.descripcion}</option>
                                ))}
                            </Select>
                        </FormControl>
                    </Grid>
                    <Grid item xs={4} sm={1} display={"flex"} alignItems={"center"}>
                        <Button variant="outlined" size="medium" fullWidth onClick={() => { fetchResults() }}>
                            <IconSearch />
                        </Button>
                    </Grid>
                    <Grid item xs={12} sm={12}>
                        <Box sx={{ display: 'grid', gridTemplateColumns: '1fr' }}>
                            <DataGridBase rows={results} columns={columns} loading={cargando} />
                        </Box>
                    </Grid>
                </Grid>
            </Grid>
        </div>
    )
}

export default Index;
